import {bounceMessage} from '../../../../../layout/userMessages/UserMessage';

interface ValidationValues {
    distributionScope: string;
    distributionPage?: string;
    displayInPop: boolean;
    link?: string;
}

interface ValidationActions {
    setSubmitting: (isSubmitting: boolean) => void;
}

const DEFAULT_PAGES = {
    event: 'realtime',
    account: 'home'
};

export const validateSystemMessage = (
    values: ValidationValues,
    actions: ValidationActions,
    t: (key: string) => string
): boolean => {
    const defaultPage = DEFAULT_PAGES[values.distributionScope];
    const isNonDefaultPage = values.distributionScope !== 'all' && 
                             values.distributionPage && 
                             values.distributionPage !== defaultPage;
    
    if(isNonDefaultPage && !values.displayInPop) {
        bounceMessage(t('displayInPopRequiredForNonDefaultPage'), 'warning');
        actions.setSubmitting(false);
        return false;
    }

    if(values.link?.startsWith('/e/') && values.distributionScope !== 'event') {
        bounceMessage(t('eventLinkRequiresEventScope'), 'warning');
        actions.setSubmitting(false);
        return false;
    }
    
    return true;
};
